import { render, staticRenderFns } from "./bar-chart.vue?vue&type=template&id=1501acac&scoped=true&"
import script from "./bar-chart.vue?vue&type=script&lang=ts&"
export * from "./bar-chart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1501acac",
  null
  
)

export default component.exports